import { type ConsumerCheckoutCartsResponse, useShowConsumerCheckout } from '@givebacks/api/store';
import { AnonymousDonationForm } from 'ui';

const CheckoutAnonymousDonationForm = () => {
  return <AnonymousDonationForm />;
};

const getAnonymousDonationAllowed = (data?: ConsumerCheckoutCartsResponse) => {
  if (!data) return false;
  return data?.checkout.allow_anonymous;
};
const CheckoutAnonymousDonationFormGuard = ({ checkoutId }: { checkoutId: string }) => {
  const { data: anonymousDonationAllowed } = useShowConsumerCheckout({
    checkoutId,
    select: getAnonymousDonationAllowed,
  });
  if (!anonymousDonationAllowed) return null;
  return <CheckoutAnonymousDonationForm />;
};

export { CheckoutAnonymousDonationFormGuard as CheckoutAnonymousDonationForm };
